import { render, staticRenderFns } from "./special.vue?vue&type=template&id=428ff6cc&scoped=true"
import script from "./special.vue?vue&type=script&lang=js"
export * from "./special.vue?vue&type=script&lang=js"
import style0 from "./special.vue?vue&type=style&index=0&id=428ff6cc&prod&lang=css"
import style1 from "./special.vue?vue&type=style&index=1&id=428ff6cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ff6cc",
  null
  
)

export default component.exports